<template>
  <section class="chess-end__body wrapper">
    <div>
      <h2>Game Notation</h2>

      <template v-if="notation.length">
        <textarea class="chess-end__pgn monospace" rows="12" v-html="notation" @change="handleEdit" />

        <div class="chess-end__copy-container">
          <template v-if="!pendingPGN">
            <button class="button copy-button" @click="handleCopy">
              Copy 
              <svg v-if="copySuccess" viewBox="0 0 18 18">
                <path d="M15.2608 7.05127L7.05125 15.2608L2.73918 10.9487" />
              </svg>
            </button>
            <div v-if="copySuccess">
              <a  href="https://www.chess.com/library?ref_id=180723553" target="_blank">Save game in Chess.com account.</a>
            </div>
          </template>
          <div v-else class="flex justify-between w-100">
            <button class="button" @click="pendingPGN = null">Discard</button>
            <button  class="button button--primary" @click="handleSave">Save</button>
          </div>
        </div>
      </template>
    </div>

      <div class="chess-end__actions">
        <button class="button" @click="$emit('hardReset')">New game</button>
        <button class="button" @click="$emit('resume')" :disabled="pendingPGN">Keep playing</button>
      </div>

  </section>
</template>

<script>
  import { Chess } from 'chess.js';

  export default {
    name: 'ChessEnd',
    props: {
      notation: {
        type: String,
        default: undefined
      }
    },
    data() {
      return {
        copySuccess: null,
        pendingPGN: null
      }
    },
    methods: {
      handleCopy() {
        navigator.clipboard.writeText(this.notation).then(
          () => {
            this.copySuccess = true;
          },
          () => {
            this.copySuccess = false;
          }
        );
      },
      handleEdit(e) {
        this.pendingPGN = this.notation.trim() != e.target.value.trim() ? e.target.value : null;
      },
      handleSave() {
        const pendingGame = new Chess();
        try {
          pendingGame.loadPgn(this.pendingPGN);
        }
        catch {
          alert('This is not valid. Notation must comply with the PGN standard.');
          return;
        }
        const currentGame = new Chess();
        currentGame.loadPgn(this.notation);
        if(pendingGame.history().length > currentGame.history().length) {
          alert('Don\'t add any moves. The number of moves should be the same.');
          return;
        }else if(pendingGame.history().length < currentGame.history().length) {
          alert('Don\'t remove any moves. The number of moves should be the same.');
          return;
        }
          
        this.$emit("save", this.pendingPGN);
        this.pendingPGN = null;
      }
    },
  }
</script>

<style>
.chess-end__body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100dvh;
}

.chess-end__copy-container {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.chess-end__body .button {
  margin-top: 16px;
}

.chess-end__copy-container .button {
  margin-top: 0;
}

:focus + .chess-end__copy-container {
  opacity: .3;
  pointer-events: none;
}


:root .copy-button svg {
  width: 1em;
}

.chess-end__actions {
  display: flex;
  flex-direction: column;
}

.chess-end__pgn {
  background: var(--plum);
  color: white;
  width: 100%;
  padding: 10px;
  border-radius: 3px;
  font-size: 16px;
  white-space: break-spaces;
}
</style>